<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="">
    <div :class="cardClass">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: null
    }
  },
  components: {},
  computed: {
    /**
     * Dynamically adds a tailwind h-{amount} class if height prop is not zero
     * @returns {string[]}
     */
    cardClass() {
      let retval = ['w-full', 'bg-gray-100', 'rounded-lg', 'bg-gray-100', 'shadow', 'p-6']

      if (this.height) {
        retval.push(`h-${this.height}`)
      }

      return retval
    }
  }
}
</script>
